module.exports = __webpack_public_path__ + "static/media/man1.58c7c5be.jpeg";